import PropTypes from "prop-types"

const NonDrilldownObjectShape = {
  name: PropTypes.string,
  data: PropTypes.number,
  count: PropTypes.number,
}

export default NonDrilldownObjectShape



// WEBPACK FOOTER //
// ./src/state/shapes/DrilldownShapes/NonDrilldownObjectShape.js